// covered-by: frontends/carrie/src/routes/settings/routes/__tests__/warholOutputSettingsFields.test.ts
import { type UpdateWarholOutputSettingsBody } from "@mg/schemas/src/christo/catalyst";
import { WARHOL_OUTPUT_FIELD_MAX_LENGTH } from "@mg/schemas/src/commons/enterprise";

export type WarholOutputFormState = UpdateWarholOutputSettingsBody;

export const WARHOL_OUTPUT_TEXT_MAX_LENGTH = WARHOL_OUTPUT_FIELD_MAX_LENGTH;

export type WarholOutputField = {
  key: keyof WarholOutputFormState;
  testId: string;
  labelKey: string;
  rows: number;
  maxLength: number;
};

export const WARHOL_OUTPUT_FIELDS: WarholOutputField[] = [
  {
    key: "claimsAdvisorInstructions",
    testId: "warhol-output-settings-claims-advisor-instructions",
    labelKey: "settings.warholOutput.claimsAdvisorInstructionsLabel",
    rows: 10,
    maxLength: WARHOL_OUTPUT_TEXT_MAX_LENGTH,
  },
  {
    key: "reportShape",
    testId: "warhol-output-settings-report-shape",
    labelKey: "settings.warholOutput.reportShapeLabel",
    rows: 8,
    maxLength: WARHOL_OUTPUT_TEXT_MAX_LENGTH,
  },
  {
    key: "replyFormat",
    testId: "warhol-output-settings-reply-format",
    labelKey: "settings.warholOutput.replyFormatLabel",
    rows: 10,
    maxLength: WARHOL_OUTPUT_TEXT_MAX_LENGTH,
  },
];

export function emptyWarholOutputForm(): WarholOutputFormState {
  return {
    claimsAdvisorInstructions: "",
    reportShape: "",
    replyFormat: "",
  };
}

export function formStateFromApi(
  data: WarholOutputFormState,
): WarholOutputFormState {
  return {
    ...emptyWarholOutputForm(),
    ...data,
  };
}
